import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import config from "../../Config";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Form } from "react-bootstrap";
import PayrollMenu from "./PayrollMenu";
import {
  PayRateAmountFields,
  filterPayRateSalaryTypes,
  formatDateInput,
} from "./PayRateAmountFields";

const DEFAULT_SCHOOL_ID = 1;

function EditPayRate() {
  const [AccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID] = useState(localStorage.getItem("ID"));
  const [MemberType] = useState(localStorage.getItem("MemberType"));
  const [validated, setValidated] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadData, setLoadData] = useState(true);
  const [loadFailed, setLoadFailed] = useState(false);
  const [loadingTypes, setLoadingTypes] = useState(true);
  const [PayRate, setPayRate] = useState(null);
  const [salaryTypes, setSalaryTypes] = useState([]);
  const [amounts, setAmounts] = useState({});

  const { id } = useParams();

  useEffect(() => {
    document.title = "Edit Pay Rate";
    if (!id) return;

    const req = {
      AccessKey,
      UserID,
      MemberType,
      pageNo: 1,
      pageSize: 2000,
      SchoolID: DEFAULT_SCHOOL_ID,
    };

    axios({
      method: "post",
      url: config.base_url + "SalaryType/GetSalaryTypes",
      headers: { "Content-Type": "application/json" },
      data: req,
    })
      .then((res) => {
        if (res.data.status_code === 1 && res.data.ListofRecords) {
          setSalaryTypes(filterPayRateSalaryTypes(res.data.ListofRecords));
        }
        setLoadingTypes(false);
      })
      .catch(() => setLoadingTypes(false));

    const data = {
      AccessKey,
      UserID,
      MemberType,
      ID: parseInt(id, 10),
    };
    axios({
      method: "post",
      url: config.base_url + "Payroll/GetPayRateByID",
      headers: { "Content-Type": "application/json" },
      data,
    })
      .then(function (response) {
        if (response.data.status_code === 1 && response.data.PayRate) {
          const pr = response.data.PayRate;
          setPayRate(pr);
          const m = {};
          if (pr.Details && pr.Details.length) {
            pr.Details.forEach((d) => {
              if (d.SalaryType_ID) m[d.SalaryType_ID] = d.Amount;
            });
          }
          setAmounts(m);
        } else {
          setLoadFailed(true);
          toast.error("Pay Rate not found.", { position: toast.POSITION.TOP_RIGHT });
        }
        setLoadData(false);
      })
      .catch(function () {
        setLoadFailed(true);
        setLoadData(false);
        toast.error("Network Error.", { position: toast.POSITION.TOP_RIGHT });
      });
  }, [id, AccessKey, UserID, MemberType]);

  const onAmountChange = (salaryTypeId, value) => {
    setAmounts((prev) => ({ ...prev, [salaryTypeId]: value }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    event.stopPropagation();
    const form = event.currentTarget;
    if (form.checkValidity() === false || !PayRate) {
      setValidated(true);
      return;
    }
    setLoading(true);

    const Details = salaryTypes.map((st) => ({
      SalaryType_ID: st.ID,
      Amount: parseFloat(amounts[st.ID]) || 0,
    }));

    const eff = form.txtEffectiveFrom?.value;
    const data = {
      AccessKey,
      UserID,
      MemberType,
      ID: PayRate.ID,
      Category: form.txtCategory.value.trim() || null,
      PayScale: parseInt(form.txtPayScale.value, 10) || 0,
      EffectiveFrom: eff ? new Date(eff + "T12:00:00").toISOString() : null,
      School_ID: parseInt(form.txtSchoolID?.value, 10) || DEFAULT_SCHOOL_ID,
      Details,
      Is_Active: form.chkIsActive.checked,
      Is_Deleted: PayRate.Is_Deleted || false,
    };

    axios({
      method: "post",
      url: config.base_url + "Payroll/SavePayRate",
      headers: { "Content-Type": "application/json" },
      data,
    })
      .then(function (response) {
        if (response.data.status_code === 1) {
          toast.success(response.data.status_message, { position: toast.POSITION.TOP_RIGHT });
          setPayRate({ ...PayRate, ...data });
        } else {
          toast.error(response.data.status_message || "Update failed.", { position: toast.POSITION.TOP_RIGHT });
        }
        setLoading(false);
      })
      .catch(function () {
        setLoading(false);
        toast.error("Network Error.", { position: toast.POSITION.TOP_RIGHT });
      });
    setValidated(true);
  };

  if (loadData) {
    return (
      <>
        <PayrollMenu />
        <div className="page-content">
          <div className="container text-center py-5">
            <Spinner animation="border" role="status"></Spinner>
            <p className="mt-2">Loading Pay Rate...</p>
          </div>
        </div>
      </>
    );
  }

  if (loadFailed || !PayRate) {
    return (
      <>
        <PayrollMenu />
        <div className="page-content">
          <div className="container py-5">
            <p>Pay rate could not be loaded.</p>
            <Link to="/Payroll/ManagePayRates">Back to Manage Pay Rates</Link>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <PayrollMenu />
      <ToastContainer />
      <div className="page-head">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to="/PayRoll/PayRollDashboard">PayRoll</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to="/Payroll/ManagePayRates">Pay Rates</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Edit Pay Rate
                  </li>
                </ol>
              </nav>
              <div className="page-title">Edit Pay Rate #{PayRate.ID}</div>
            </div>
            <div className="col-md-6">
              <div className="page-right-actions">
                <Link to="/Payroll/ManagePayRates" className="button button-white button-icon">
                  Manage Pay Rates
                  <i className="ri-list-check"></i>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="page-content">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-12">
              <div className="card">
                <div className="card-body">
                  <Form noValidate validated={validated} onSubmit={handleSubmit}>
                    <div className="row">
                      <div className="col-md-4">
                        <div className="form-group mb-3">
                          <label>Category</label>
                          <input
                            type="text"
                            className="form-control"
                            name="txtCategory"
                            defaultValue={PayRate.Category}
                            placeholder="e.g. Principal, Teachers / Admin O"
                            maxLength={2000}
                            required
                          />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group mb-3">
                          <label>Pay Scale</label>
                          <input
                            type="number"
                            className="form-control"
                            name="txtPayScale"
                            required
                            min="0"
                            defaultValue={PayRate.PayScale}
                          />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group mb-3">
                          <label>Effective from</label>
                          <input
                            type="date"
                            className="form-control"
                            name="txtEffectiveFrom"
                            required
                            defaultValue={formatDateInput(PayRate.EffectiveFrom)}
                          />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group mb-3">
                          <label>School ID</label>
                          <input
                            type="number"
                            className="form-control"
                            name="txtSchoolID"
                            min="1"
                            defaultValue={PayRate.School_ID || DEFAULT_SCHOOL_ID}
                            required
                          />
                        </div>
                      </div>
                      <div className="col-12">
                        <h6 className="mb-2 mt-2">Component amounts</h6>
                        {loadingTypes ? (
                          <Spinner animation="border" size="sm" />
                        ) : (
                          <PayRateAmountFields
                            salaryTypes={salaryTypes}
                            amounts={amounts}
                            onAmountChange={onAmountChange}
                            disabled={loading}
                          />
                        )}
                      </div>
                      <div className="col-md-4 d-flex align-items-end">
                        <div className="form-group mb-3">
                          <Form.Check
                            type="checkbox"
                            name="chkIsActive"
                            label="Active"
                            defaultChecked={PayRate.Is_Active !== false}
                          />
                        </div>
                      </div>
                      <div className="col-md-12">
                        {loading ? (
                          <Spinner animation="border" role="status"></Spinner>
                        ) : (
                          <button type="submit" className="button button-primary" disabled={loadingTypes}>
                            UPDATE
                          </button>
                        )}
                      </div>
                    </div>
                  </Form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default EditPayRate;
